import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '../basic'
const IFrame = () => import('@/views/iframe/FrameBlank.vue')

const receiptRoute: RouteRecordRaw = {
  path: '/',
  component: Layout,
  children: [
    {
      path: 'printer-setting',
      name: 'PrinterSettingMain',
      component: () => import('@/views/printerSetting/indexV2.vue'),
      meta: {
        title: '打印机设置',
        icon: 'menu-cangkujichu',
        transitionName: 'none',
      },
    },
    {
      path: 'addAppointment',
      name: 'addAppointment',
      component: IFrame,
      meta: {
        title: '测试页面',
        frameSrc: '/print.html',
      },
    },
  ],
}

export default receiptRoute
